module.exports = __webpack_public_path__ + "static/Makook_Studio-c742aec7adb2b84acfea6c52b5707531.jpg";